import React from "react";
import type { TFunction } from "i18next";
import type { Module } from "src/system/module.types.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import type { CountryResource } from "@exonn/js-sdk";

export const module: Module<CountryResource> = {
  id: ResourceEnum.Country,
  bigIcon: <i className="icon-20-countries" />,
  smallIcon: <i className="icon-15-countries" />,
  name: (t: TFunction) => t("moduleName.countries"),
  list: {
    hideDeleteAction: (row) => row.is_default,
  },
  tabs: {
    edit: {
      getTitle: (resource) => resource.name,
    },
  },
};
